var React = require('react');

function SignalAlt2 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M576 0h-32a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM416 128h-32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M96 384H64a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32zm160-128h-32a32 32 0 0 0-32 32v192a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V288a32 32 0 0 0-32-32z","className":"fa-primary","key":2})]);
}

SignalAlt2.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = SignalAlt2;

SignalAlt2.default = SignalAlt2;
